import { render, staticRenderFns } from "./colorContrast.vue?vue&type=template&id=fc0760d8&"
import script from "./colorContrast.vue?vue&type=script&lang=js&"
export * from "./colorContrast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fc0760d8', component.options)
    } else {
      api.reload('fc0760d8', component.options)
    }
    module.hot.accept("./colorContrast.vue?vue&type=template&id=fc0760d8&", function () {
      api.rerender('fc0760d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Settings/colorContrast.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/colorContrast.vue
// module id = V/Z2
// module chunks = 0